import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    ProductTemperatureInternationalForm,
    ProductTemperatureInternationalFormGroup
} from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { ItemCondition } from '@cod-monorepo/interfaces';
import { ItemConditionMapping } from '../../../../shared/mappings/item-condition.mapping';
import { TemperatureExcursionLocation } from '@cod-monorepo/interfaces';
import { TemperatureExcursionIdentifier } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-product-temperature-international-step',
    templateUrl: './product-temperature-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodProductTemperatureInternationalStepComponent extends BaseInternationalStep implements OnInit {
    @Input() productTemperatureInternationalForm: FormGroup<ProductTemperatureInternationalFormGroup> | undefined;

    public itemConditions = ItemCondition;
    public itemConditionMapping = ItemConditionMapping;
    public temperatureExcursionLocations = TemperatureExcursionLocation;
    public temperatureExcursionIdentifier = TemperatureExcursionIdentifier;

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.initCarrierClaimFiledListener();
    }

    public isDefined(control: keyof ProductTemperatureInternationalForm): boolean {
        return this.productTemperatureInternationalForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof ProductTemperatureInternationalForm): boolean {
        return this.productTemperatureInternationalForm?.controls[control].value === true;
    }

    public isFalse(control: keyof ProductTemperatureInternationalForm): boolean {
        return this.productTemperatureInternationalForm?.controls[control].value === false;
    }

    public itemConditionSelected(condition: ItemCondition): boolean {
        return this.productTemperatureInternationalForm?.controls.itemCondition.value?.includes(condition) ?? false;
    }

    public toggleItemCondition(condition: ItemCondition): void {
        const itemCondition = this.productTemperatureInternationalForm?.controls.itemCondition;

        if (itemCondition) {
            const conditions = itemCondition.value ?? [];

            if (conditions.includes(condition)) {
                itemCondition.setValue(conditions.filter(c => c !== condition));
            } else {
                itemCondition.setValue([...conditions, condition]);
            }
        }
    }

    public handleConfirm() {
        if (this.productTemperatureInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.productTemperatureInternationalForm?.valid ?? false;
    }

    private initCarrierClaimFiledListener(): void {
        this.productTemperatureInternationalForm?.controls.claimFiled.valueChanges.subscribe(value => {
            if (value === false) {
                this.store.dispatch(new AddErrorMessage(WorkflowError.PLEASE_FILE_CARRIER_CLAIM));
            } else {
                this.store.dispatch(new RemoveErrorMessage(WorkflowError.PLEASE_FILE_CARRIER_CLAIM));
            }
        });
    }
}
